var _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInfoOutline20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
  id: "ic_info-outline_20x20_svg__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#ic_info-outline_20x20_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M10 1.25a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m.25 5.75a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5zm.125-3a.5.5 0 0 1 .5.5v.75a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5z"
}))));
export default SvgIcInfoOutline20X20;